import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findDetails = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v1/appointment-card?` + params,
        method: 'GET'
    })
}

// export const getReceivedInfo = (id) => {
//     return request({
//         url: `${baseUrl}/joins-sales/v1/redPacket/getReceivedInfo/${id}`,
//         method: 'GET'
//     })
// }

// export const findLabelList = (params) => {
//     params = parseParam(params)
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/label/select?` + params,
//         method: 'GET'
//     })
// }

// export const addTags = (params) => {
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/label`,
//         method: 'POST',
//         data: params
//     })
// }
// export const editTags = (params) => {
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/label`,
//         method: 'PUT',
//         data: params
//     })
// }

// export const delTags = (ids) => {
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/label/${ids}`,
//         method: 'DELETE',
//     })
// }